import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import HarbourBrandLockup from '../components/harbour/HarbourBrandLockup';
import HarbourNotice from '../components/harbour/HarbourNotice';
import HarbourButton from '../components/harbour/HarbourButton';
import { rmsHomeFor } from '../utils/rmsHome';
import '../components/harbour/harbour.css';

/*
 * Anything under /rms that matches no page. Without this the router renders
 * nothing and a mistyped or expired address is a blank white screen, which
 * reads as the service being broken.
 *
 * It follows the portal's "Could not load" pattern (3370:52085 and its
 * overlay 3370:52471; R-013, TDI-697): the error notice, Try again on the same
 * address, then the way to the person's own home, which only their role's
 * page can be. The design has no visible heading here, so the page's heading
 * is for screen readers only.
 */
export default function RmsNotFoundPage() {
  const navigate = useNavigate();
  const { user, claims } = useAuth();
  const home = rmsHomeFor({ signedIn: Boolean(user), userType: claims && claims.userType });

  return (
    <div className="harbour harbour-page">
      <div className="mx-auto w-full max-w-[1720px] px-6 xl:px-10 py-6 flex flex-col gap-6">
        <header className="harbour-top-bar">
          <HarbourBrandLockup />
        </header>
        <main className="rms-could-not-load">
          <h1 className="sr-only">We could not load this page right now</h1>
          <HarbourNotice kind="error" title="We could not load this page right now">
            Check your connection, then try again.
          </HarbourNotice>
          <div className="flex flex-wrap items-center gap-3">
            {/* Reloads the same address: history.go(0) under the browser router. */}
            <HarbourButton kind="secondary" onClick={() => navigate(0)}>
              Try again
            </HarbourButton>
            <HarbourButton kind={home.family ? 'family' : 'primary'} onClick={() => navigate(home.to)}>
              {home.label}
            </HarbourButton>
          </div>
        </main>
      </div>
    </div>
  );
}
